var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "sweet-modal",
    {
      ref: "modal",
      attrs: { "overlay-theme": "dark", "enable-mobile-fullscreen": false }
    },
    [
      _c("img", {
        staticClass: "img-instant-booking",
        attrs: { src: _vm.imageUrl, alt: "" }
      }),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c("h3", [_vm._v(_vm._s(_vm.$t("message.instant_booking.title")))]),
      _vm._v(" "),
      _c("div", { staticClass: "text-remark" }, [
        _vm._v(_vm._s(_vm.$t("message.instant_booking.detail")))
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3c619e73", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c619e73","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/InstantBookingModal.vue
// module id = 1885
// module chunks = 0